import PropTypes from 'prop-types';
import React from 'react';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Text} from '../../ui';
import css from '../styles/CourseInfo.module.css';

const CourseInfo = ({text, title}) => {
  return (
    <div>
      <div className={css.title}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_36}
          fontFamily={Text.FONT_FAMILY.RUBIK}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
          tagComponent={Text.TAG.SPAN}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={title} />
        </Text>
      </div>
      <Text
        fontSize={Text.FONT_SIZE.SIZE_16}
        lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
        color={Text.COLOR.GREY}
      >
        {text}
      </Text>
    </div>
  );
};

CourseInfo.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CourseInfo;
